import { c } from '../';
import { dispatch } from '../internal';
import { setSelectedCreditorId } from '../internal';
import * as actionTypes from './actionTypes';
export const select = (selected) => {
    setSelectedCreditorId(selected);
    c.insights.setSelectedCreditors([selected]);
    dispatch({ type: actionTypes.SELECT_CREDITOR, payload: { selected } });
};
//# sourceMappingURL=actions.js.map